/* eslint-disable no-shadow,no-param-reassign */

const initialState = {
  templates: {}
};

export const state = initialState;

export const getters = {
  templates: state => state.templates
};

export const actions = {
  setList({ commit }, payload) {
    commit("setList", payload);
  },
  add({ commit }, payload) {
    commit("add", payload);
  }
};

export const mutations = {
  setList(state, templates) {
    state.templates = templates;
  },
  add(state, template) {
    state.templates = Object.assign(state.templates, template);
  }
};
